export const pluralize = <T>(type: string): keyof T => `${type}s` as keyof T
